export { default as HelpHome } from './connectedHelpHome';
